module.exports = __webpack_public_path__ + "img/close.553e322a.svg";